import React from "react";
import { Box, Card, Skeleton } from "@mui/material";

const SkeletonLoader = ({ type = "pharmaHistoryCards", cardCount = 1 }) => {
  if (type === "pharmaHistoryCards") {
    return (
      <Box sx={{ px: "10px", py: "6px" }}>
        {Array.from({ length: cardCount }).map((_, cardIndex) => (
          <Card
            key={cardIndex}
            elevation={0}
            sx={{
              borderRadius: "12px",
              border: "1px solid #eaeaea",
              marginBottom: cardIndex === cardCount - 1 ? "0px" : "12px",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "10px",
                px: "16px",
                py: "12px",
                borderBottom: "1px solid #eaeaea",
                background: "#fff",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Skeleton variant="circular" width={18} height={18} />
                <Skeleton variant="text" width={110} height={24} />
                <Skeleton
                  variant="rounded"
                  width={72}
                  height={22}
                  sx={{ borderRadius: "7px" }}
                />
              </Box>
              <Skeleton variant="text" width={52} height={20} />
            </Box>

            <Box sx={{ px: "14px", py: "12px", background: "#fff" }}>
              <Box sx={{ overflowX: "auto" }}>
                <Box
                  component="table"
                  sx={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    minWidth: "1280px",
                  }}
                >
                  <Box component="thead">
                    <Box component="tr">
                      {Array.from({ length: 11 }).map((_, columnIndex) => (
                        <Box
                          key={columnIndex}
                          component="th"
                          sx={{
                            padding: "10px 8px",
                            borderBottom: "1px solid #eaeaea",
                          }}
                        >
                          <Skeleton variant="text" width="70%" height={18} />
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  <Box component="tbody">
                    {Array.from({ length: 3 }).map((_, rowIndex) => (
                      <Box component="tr" key={rowIndex}>
                        {Array.from({ length: 11 }).map((_, columnIndex) => (
                          <Box
                            key={columnIndex}
                            component="td"
                            sx={{
                              padding: "12px 8px",
                              borderBottom: "1px solid #f3f4f6",
                            }}
                          >
                            <Skeleton
                              variant="text"
                              width={columnIndex % 2 === 0 ? "80%" : "60%"}
                              height={20}
                            />
                          </Box>
                        ))}
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Card>
        ))}
      </Box>
    );
  }

  if (type === "pharmaNewEntry") {
    return (
      <Box sx={{ display: 'grid', gap: 2 }}>
        {Array.from({ length: cardCount }).map((_, cardIndex) => (
          <Card
            key={cardIndex}
            elevation={0}
            sx={{
              borderRadius: "12px",
              border: "1px solid #eaeaea",
              p: 2,
              bgcolor: '#fff',
            }}
          >
            {/* Header Skeleton restored to Neutral Look */}
            <Box 
              sx={{ 
                mb: 2, 
                display: 'inline-flex', 
                bgcolor: '#F8FAFC', 
                borderRadius: '6px',
                px: 1.5,
                py: 0.5,
                borderLeft: '4px solid #E2E8F0'
              }}
            >
              <Skeleton variant="text" width={100} height={20} />
            </Box>

            {/* Grid of Fields Skeleton */}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(2, 1fr)',
                  md: 'repeat(5, 1fr)'
                },
                gap: 1.5
              }}
            >
              {Array.from({ length: 10 }).map((_, fieldIndex) => (
                <Box key={fieldIndex}>
                  <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: '8px' }} />
                </Box>
              ))}
            </Box>
          </Card>
        ))}
      </Box>
    );
  }

  return null;
};

export default SkeletonLoader;
